// ContactSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import instagramIcon from '../asset/instargramIcon.png'; // 인스타그램 아이콘 이미지 경로
import emailIcon from '../asset/emailIcon.png'; // 이메일 아이콘 이미지 경로

const ContactSection = ({ instagram, email }) => {
  return (
    <section className="contact">
      <Link to="https://www.instagram.com/unistudio_juok/">
        <div className="contact-item">
          <img src={instagramIcon} alt="Instagram" className="contact-icon" />
          <span>{instagram}</span>
        </div>
      </Link>
      <div className="contact-item">
        <img src={emailIcon} alt="Email" className="contact-icon" />
        <span>{email}</span>
      </div>
    </section>
  );
}

export default ContactSection;
